export default class MessageAppInfo {
  constructor (data) {
    this.id = data.id;
    this.name = data.name;
    this.ios = data.ios;
    this.android = data.android;
    this.createdat = data.createdat;
  }
}
